import Vue from 'vue';

const EventBus = new Vue();
export default EventBus;

export const SHOW_FILE = 'show_file';
export const SHOW_NEW_APP_VERSION = 'show_new_app_version';
